import { Pipe, PipeTransform } from '@angular/core';
import { ZSNParcel } from '../models/zsn.model';

// FIXME mettre en commun avec ble et orge

@Pipe({
  name: 'zsnParcelOrderStatus',
  standalone: true,
})
export class ZSNParcelOrderStatusPipe implements PipeTransform {
  transform(parcel: ZSNParcel, attr: any): any {
    if (!parcel.orderItem) {
      return 'Non commandée';
    } else {
      if (parcel.orderItem.order) {
        const text = 'Commandée';
        return text;
      } else {
        return 'Non commandée';
      }
    }
  }
}

@Pipe({
  name: 'zsnParcelAgroStatus',
  standalone: true,
})
export class ZSNParcelAgroStatusPipe implements PipeTransform {
  transform(parcel: ZSNParcel, attr: any): any {
    if (!parcel.orderItem) {
      return 'Non complétée';
    } else {
      if (!parcel.orderItem.completed) {
        return 'Incomplète';
      } else {
        return 'Complétée';
      }
    }
  }
}
